/**
 * `/wideo` — the video module's address while it was a screen pointing to the mobile app (23 September
 * 2026). Since 24 September the module is the recordings gallery at `/nagrania` (owner: the gallery
 * IS the video module), so the old address redirects there and a bookmark or an old link still lands.
 *
 * `replace: true`, so the old address leaves no history entry behind: Back from the gallery goes
 * wherever the trainer was before, not to `/wideo`, which would bounce them forward again.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_shell/wideo')({
  beforeLoad: () => {
    // `throw: true` makes `redirect` raise the router's own Response itself; see `_shell.tsx`.
    redirect({ to: '/nagrania', replace: true, throw: true });
  },
});
